import { Flex, FlexProps } from 'rebass';
import React from 'react';

type FormRowProps = FlexProps & {
  children: React.ReactNode;
};

const FormRow = (props: FormRowProps): JSX.Element => {
  return (
    <Flex
      {...(props as any)}
      className="form-row"
      sx={{
        ...(props.sx ?? {}),
        '@media screen and (max-width:52em)': {
          flexDirection: 'column',
        },
        '> .form-column': {
          flex: 1,
          mr: 3,
          ':last-child': {
            mr: 0,
          },
          '@media screen and (max-width:52em)': { mr: 0, flexGrow: 0 },
        },
      }}
    >
      {props.children}
    </Flex>
  );
};

export default FormRow;
